(() => {
  angular
    .module('app.campaign')
    .controller('CampaignQualityController', CampaignQuality);

  CampaignQuality.$inject = [
    '$scope',
    '$route',
    'CampaignManagerService',
    'AvailableQualityMetrics',
  ];

  function CampaignQuality(
    $scope,
    $route,
    CampaignManagerService,
    AvailableQualityMetrics,
  ) {
    const vm = this;
    const METRICS = [{
      name: 'geoCompliance',
      title: 'Geo Compliance',
      // description: 'Does the ad load in the correct geographical area?'
    }, {
      name: 'brandSafety',
      title: 'Brand Safety',
      // description: 'Does the ad appear alongside negative listed content?'
    }, {
      name: 'relevance',
      title: 'Relevance',
      // description: 'Does the ad appear alongside relevant content?'
    }, {
      name: 'mediaQuality',
      title: 'Media Quality',
      // description: 'Does the ad appear on safe and popular medias?'
    }, {
      name: 'viewability',
      title: 'Viewability',
      // description: 'Are ads viewable for human eyes?'
    }, {
      name: 'bots',
      title: 'Bots',
      // description: 'Are ads loaded by suspicious devices?'
    }, {
      name: 'adCollision',
      title: 'Ad Collision',
      // description: 'Are ads shown multiple times at the same location?'
    }, {
      name: 'transparency',
      title: 'Transparency',
      // description: 'Does the provider try to obscure where the ad is served?'
    }];

    const availableQualityMetrics = angular.isUndefined(AvailableQualityMetrics) ? [] : AvailableQualityMetrics;

    vm.campaign = CampaignManagerService.getCampaignData();

    vm.mode = $route.current.params.mode;

    vm.isStandardCampaign = () => {
      return vm.campaign && vm.campaign.type === 'standard';
    }

    vm.isCampaignInSource = () => vm.campaign.sources.some(source => source.provider === 'audiencereport');
    vm.getCampaignSourceId = () => vm.campaign.sources.find(source => source.provider === 'audiencereport').id;

    vm.qualityMetricsList = {
      availableQualityMetrics: availableQualityMetrics.map(metric => {
        const { qualityMetrics } = vm.campaign;
        const aqm = METRICS.find(item => item.name === metric.name);
        const qm = qualityMetrics && qualityMetrics.find(item => item.name === metric.name);
        return {
          title: aqm.title,
          score: qm ? qm.score : 0,
          name: metric.name,
          icon: metric.name,
          description: metric.description,
        };
      }),
      enabledQualityMetrics: vm.campaign.qualityMetrics || [],
      totalScore: vm.mode === 'edit' && getTotalScore(),
      toggle: function(metric) {
        if (!this.isEnabled(metric.name)) {
          this.enabledQualityMetrics.push({
            name: metric.name
          });
        } else {
          this.enabledQualityMetrics = this.enabledQualityMetrics.filter(enabledQualityMetric => (
            enabledQualityMetric.name !== metric.name
          ));
        }

        vm.campaign.qualityMetrics = this.enabledQualityMetrics;
      },
      isEnabled: function(name) {
        return !!this.enabledQualityMetrics.find(enabledQualityMetric => enabledQualityMetric.name === name);
      },
      selectAll: function() {
        this.enabledQualityMetrics = this.availableQualityMetrics.map(metric => ({
          name: metric.name
        }));

        vm.campaign.qualityMetrics = this.enabledQualityMetrics;
      }
    };

    if (vm.mode === 'create') {
      vm.qualityMetricsList.selectAll();
    }

    function getTotalScore() {
      const total = availableQualityMetrics.reduce((memo, metric) => memo + metric.score, 0) / availableQualityMetrics.length;

      return Math.round(total);
    }

    /* Persist changes to service */
    $scope.$watch(() => vm.campaign,
    campaign => {
      CampaignManagerService.setCampaignData(campaign);
    }, true);
  }
})();
